import {useEffect, useMemo, useRef, useState} from "react";
import {Department} from "domain/types/clientMetadataTypes";
import {ClientMetadataService} from "application/services/ClientMetadata.service";
import {HttpClientMetadataRepository} from "infrastructure/repositories";

export const useClientMetadata = () => {
    const [departments, setDepartments] = useState<Department[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const service = useMemo(
        () => new ClientMetadataService(new HttpClientMetadataRepository()),
        []
    );

    const didFetch = useRef(false);

    useEffect(() => {
        if (didFetch.current) return;
        didFetch.current = true;

        const fetchMetadata = async () => {
            const campaignId = localStorage.getItem("campaign");
            if (!campaignId) {
                setError("No se encontró el ID de campaña en localStorage.");
                setLoading(false);
                return;
            }
            try {
                const resp = await service.getClientMetadata(campaignId);
                if (resp && resp.departments) {
                    const filtered = resp.departments.filter(
                        (dep) => dep.occupations && dep.occupations.length > 0
                    );
                    setDepartments(filtered);
                } else {
                    setDepartments([]);
                }
            } catch (e) {
                setError("No fue posible cargar la metadata del cliente.");
                setDepartments([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMetadata();
    }, [service]);

    return {
        departments,
        loading,
        error,
    };
};
